import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircleIcon, FrownIcon, HeartCrackIcon, HomeIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  const painPoints = [{
    icon: <FrownIcon className="w-6 h-6 text-red-500" data-id="element-125" />,
    text: 'Tu hijo ya no juega con ilusión, sino con miedo y presión.'
  }, {
    icon: <TrendingDownIcon className="w-6 h-6 text-red-500" data-id="element-126" />,
    text: 'Sabes que puede llegar lejos, pero un error lo hunde y le destruye la confianza.'
  }, {
    icon: <HomeIcon className="w-6 h-6 text-red-500" data-id="element-127" />,
    text: 'La presión del fútbol ya se siente también en tu casa, antes y después de cada partido.'
  }, {
    icon: <HeartCrackIcon className="w-6 h-6 text-red-500" data-id="element-128" />,
    text: 'Quieres volver a disfrutar, mejorar el rendimiento y fortalecer la mente dentro y fuera del campo.'
  }];
  return <section className="py-20 md:py-28 bg-white" data-id="element-129">
      <div className="max-w-2xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-131">
          <h2 className="md:text-4xl font-heading text-brand-slate text-[35px]" data-id="element-132">
            Este producto es para ti si...
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-133">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex items-start p-5 md:p-6 bg-white rounded-2xl border border-gray-100" data-id="element-134">
              <div className="flex-shrink-0 mr-4 mt-0.5 p-2.5 rounded-xl bg-[#FFEDED]" data-id="element-135">
                {point.icon}
              </div>
              <p className="text-base md:text-lg text-brand-slate-light leading-relaxed" data-id="element-136">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}